// Business codes zahrada puts at `message.code` on a device or device-settings rejection.
export const DEVICE_FAMILY_REQUIRED_ERROR_CODE = 'DEVICE_FAMILY_REQUIRED';
export const DEVICE_PROFILE_NOT_READY_ERROR_CODE = 'DEVICE_PROFILE_NOT_READY';
export const DEVICE_FAMILY_ALREADY_BOUND_ERROR_CODE = 'DEVICE_FAMILY_ALREADY_BOUND';

// Device clocks drift; past this the device-reported time is flagged against the server time.
export const CLOCK_SKEW_WARN_MS = 5000;
